import * as Alertify from 'alertifyjs';

import '../polyfills/String.width';
import '../polyfills/Math.roundDecimals';
import 'mdn-polyfills/CustomEvent';

import 'classlist-polyfill';
import 'mdn-polyfills/String.prototype.repeat';
import 'core-js/modules/es.number.parse-float';

import '../legacy/jquery.helper';
import '../legacy/jquery.required_validate';

import './fallco_console';
import './filtri';
import './notify';
import './ajax';
import './tipizzazione';
import './pagination';
import './formHelper';
import './formFiller';
import './controlsBinding';
import './templates';
import './utilities';
import './performance';
import {merge as _merge} from "lodash";

window.alertify = Alertify;

/**
 * La variabile window.alertifySettings pu� essere definita dove viene incluso questo bundle
 * nel caso non fosse definita la definiamo qui sotto e poi la mergiamo con i setting di default della libreria
 */

if (!window.alertifySettings) {
  window.alertifySettings = {
    // dialogs defaults
    closable: false,
    closableByDimmer: false,
    maximizable: false,
    modal: true,
    movable: false,
    pinnable: false,
    resizable: false,
    transition: 'fade',
    // notifier defaults
    notifier: {
      // auto-dismiss wait time (in seconds)
      delay: 5,
      // default position
      position: 'bottom-right',
      // adds a close button to notifier messagespdv_servizio_caricamento
      closeButton: false,
      // provides the ability to rename notifier classes
      classes: {
        base: 'alertify-notifier alert-simple'
      }
    },
    // language resources
    glossary: {
      // dialogs default title
      title: 'FallcoWeb',
      // ok button text
      ok: 'OK',
      // cancel button text
      cancel: 'Annulla'
    },

    // theme settings
    theme: {
      // class name attached to prompt dialog input textbox.
      input: 'form-control',
      // class name attached to ok button
      ok: 'btn btn-default',
      // class name attached to cancel button
      cancel: 'btn btn-default'
    },
    hooks: {
      // invoked before initializing any dialog
      postinit: function (instance) {
        instance.set({
          'onfocus': function () {
            var oldCloseFucntion = instance.get("onclose");

            instance.set({
              onclose: function () {
                if (this.destroying) {
                  this.destroying = false;

                  return;
                }

                if (oldCloseFucntion) {
                  oldCloseFucntion();
                }

                this.destroying = true;
                this.destroy();
              }
            })
          }
        });
      },
    }
  };
}

_merge(window.alertify.defaults, window.alertifySettings);